<admin-app-header></admin-app-header>
<app-prospecting-nav></app-prospecting-nav>

<div class="board-page">
    <div class="board-toolbar">
        <div class="toolbar-left">
            <h1><i class="fa-solid fa-table-columns"></i> Prospecting Board</h1>
            <span class="count-badge">{{ allProspects.length | number }} prospects</span>
        </div>
        <div class="toolbar-filters">
            <select [(ngModel)]="assigneeFilter" (ngModelChange)="applyFilters()">
                <option value="">All assignees</option>
                <option *ngFor="let a of assignees" [value]="a.$key">{{ a.displayName }}</option>
            </select>
            <select [(ngModel)]="sourceFilter" (ngModelChange)="applyFilters()">
                <option value="">All sources</option>
                <option *ngFor="let s of sourceOptions" [value]="s">{{ sourceLabels[s] }}</option>
            </select>
            <select [(ngModel)]="searchTermFilter" (ngModelChange)="applyFilters()">
                <option value="">All search terms</option>
                <option *ngFor="let t of searchTermOptions" [value]="t">{{ t }}</option>
            </select>
            <select [(ngModel)]="prospectTypeFilter" (ngModelChange)="applyFilters()">
                <option value="">All types</option>
                <option *ngFor="let t of prospectTypeOptions" [value]="t">{{ prospectTypeLabels[t] }}</option>
            </select>
            <button class="archive-toggle" [class.active]="showArchived" (click)="toggleArchived()">
                <i class="fa-solid" [class.fa-eye]="!showArchived" [class.fa-eye-slash]="showArchived"></i>
                {{ showArchived ? 'Hide archived' : 'Show archived' }}
            </button>
        </div>
    </div>

    <div class="loading-state" *ngIf="loading">
        <i class="fa-solid fa-spinner fa-spin"></i> Loading prospects...
    </div>

    <div class="kanban" *ngIf="!loading">
        <div class="kanban-col" *ngFor="let col of columns">
            <div class="kanban-col__header">
                <span class="col-dot" [style.background-color]="col.color"></span>
                <span class="col-title">{{ col.label }}</span>
                <span class="col-count">{{ col.prospects.length }}</span>
            </div>

            <div
                class="kanban-col__body"
                cdkDropList
                [id]="columnId(col.status)"
                [cdkDropListData]="col.prospects"
                [cdkDropListConnectedTo]="connectedLists"
                (cdkDropListDropped)="onDrop($event, col.status)"
            >
                <div class="kanban-card" *ngFor="let p of col.prospects" cdkDrag (click)="openProspect(p)">
                    <div class="card-top">
                        <img *ngIf="p.logoUrl" [src]="p.logoUrl" class="card-logo" (error)="p.logoUrl = ''" />
                        <div class="card-name">{{ p.name }}</div>
                    </div>
                    <div class="card-domain" *ngIf="p.domain"><i class="fa-solid fa-globe"></i> {{ p.domain }}</div>
                    <div class="card-meta" *ngIf="nearestLabel(p)"><i class="fa-solid fa-square-parking"></i> {{ nearestLabel(p) }}</div>
                    <div class="card-footer">
                        <span class="card-tag" *ngIf="p.industry">{{ p.industry }}</span>
                        <span class="card-contacts" *ngIf="p.contactCount"><i class="fa-solid fa-address-book"></i> {{ p.contactCount }}</span>
                    </div>
                </div>

                <div class="kanban-empty" *ngIf="col.prospects.length === 0">
                    <i class="fa-regular fa-rectangle-list"></i>
                    <span>Empty</span>
                </div>
            </div>
        </div>
    </div>
</div>
